/**
 * Popup
 *
 * @module popup
 */
 const component = {

    /**
     * Init module
     * 
     * @returns {boolean|undefined}
     */
    init: () => {

		component.target = document.querySelector("[data-popup]");

		if(!component.target) return false;

        component._initCloseEvents();
        component._open();
	},

    /**
	 * start to listen the click button to close popup
     * @returns {undefined}
	 */
    _initCloseEvents: () => {
        document.querySelector('[data-popup-close]').addEventListener('click', (event) => {
			event.preventDefault();
			component._close();
		});
    },

    /**
     * Close popup
     * 
     * @returns {undefined}
     */    
    _close: () => {
        
		component.disableFocusTrap();

        setTimeout(() => {
            component.target.classList.remove("active");
			component.target.setAttribute('aria-hidden', 'true');
        }, 50);
    },

    /**
     * Open popup
     * 
     * @returns {undefined}
     */
    _open: () => {
        setTimeout(() => {
            component.target.classList.add("active");
            component.target.setAttribute('aria-hidden', 'false');
            component.activeFocusTrap();
        }, 50); 
    },

    /**
     * Init popup focus trap
     * 
     * @returns {undefined}
     */
    initFocusTrap: () => {
        component.focusTrap = focusTrap.createFocusTrap(component.target, { clickOutsideDeactivates: true });
    },

    /**
     * Ative popup focus trap
     * 
     * @returns {undefined}
     */
    activeFocusTrap: () => {
        if (component.focusTrap) {
            component.focusTrap.activate();
        }
    },

    /**
     * Disable popup focus trap
     * 
     * @returns {undefined}
     */
    disableFocusTrap: () => {
        if (component.focusTrap) {
            component.focusTrap.deactivate();
        }
    }

}

export default component;